// extracted by mini-css-extract-plugin
export default {"text":"OverflowText_text__dHxDh","oneLiner":"OverflowText_oneLiner__d5imq","tooltip":"OverflowText_tooltip__a0aan"};